<div class="frc__top container-fluid" #header tabindex="-1">
  <app-back-button></app-back-button>
  <div class="top-layout-grid row">

    <div class="col content-wrapper">
      <div class="top-layout-grid__image-wrapper mr-4">
        <div *ngIf="showBiography" class="top-layout-grid__image">
          <app-cover
            [config]="coverConfig"
            data-automation-id="full-card-image"
            size="medium">
          </app-cover>
        </div>
      </div>

      <div class="top-layout-grid__links">
        <app-inn-reach-search *ngIf="isInnReachSearchAvailable"
                              [searchData]="searchData"
                              [isFullCard]="true"
                              class="inn-reach">
        </app-inn-reach-search>
      </div>

      <div class="top-layout-grid__content d-flex flex-column">
        <h2 class="title mb-0 line-clamp line-clamp--two"
          *ngIf="data?.title"
          [tippy]="data.title"
          data-automation-id="full-card-title">
          {{ data.title }}
        </h2>
      </div>

      <div class="toolbar">
        <app-toolbar-line [data]="data" [entity]="originalData"></app-toolbar-line>
      </div>

      <div class="description mt-1" data-automation-id="full-card-biography" *ngIf="showBiography">
        <app-syndetics-unbound-author-bio [isbn]="data?.bookIsbn"></app-syndetics-unbound-author-bio>
      </div>

      <div class="description mt-3" data-automation-id="full-card-description" *ngIf="descriptionVisibilityCondition">
        <app-cut-text-with-certain-height
          [text]="textInsideDescription"
          [source]="sourceDescription"
          [url]="fullCardDescriptionUrl"
          height="70"
          class="more-less-link-frc"
          moreLessColor="#0096ad"
          minLengthToCut="60">
        </app-cut-text-with-certain-height>
      </div>
    </div>
  </div>
</div>
